(function () {
  document.querySelectorAll('[data-acc02-video]').forEach(function (wrap) {
    var video = wrap.querySelector('video');
    var playBtn = wrap.querySelector('[data-acc02-video-play]');
    if (!video || !playBtn) return;

    function play() {
      video.play();
      wrap.classList.add('is-playing');
    }
    function pause() {
      video.pause();
      wrap.classList.remove('is-playing');
    }

    playBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      play();
    });
    wrap.addEventListener('click', function () {
      if (video.paused) {
        play();
      } else {
        pause();
      }
    });
    video.addEventListener('ended', pause);
  });
})();
